// Text fields of chats/notes: the text is NEVER changed automatically (no autocorrect, auto-capital, autocomplete);
// misspelled words are only underlined in red by the browser's own spell checker (local, no server call).
export const NO_AUTOCORRECT = { spellCheck: true, autoCorrect: "off", autoCapitalize: "off", autoComplete: "off", lang: "it" };
